import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import createPersistedState, { Options } from 'vuex-persistedstate';

import PaginationStore from './pagination.module';
import SessionStore from './session.module';

Vue.use(Vuex);

export class StoreSingleton {
  private static store: Store<any>;

  static getInstance() {
    if (!this.store) {
      this.store = new Vuex.Store({
        modules: {
          sessionStore: SessionStore,
          paginationStore: PaginationStore,
        },
        plugins: [
          createPersistedState(
            {
              storage: window.localStorage,
              paths: ['sessionStore', 'paginationStore'],
            } as Options /** TODO: remover 'as', biblioteca com problema de tipagem */,
          ),
        ],
      });
    }
    return this.store;
  }
}

export default StoreSingleton.getInstance();
